(function() {
	Vue.component('nominow-pagination', {
		props: {
			pagination: {
				type: Object,
				required: true,
				default: () => ({
					max: 999,
					pagesize: 10,
					currentpage: 0
				})
			}
		},
		template: `
    <nav class="pagination is-centered" role="navigation" aria-label="pagination" v-if="pagination.max > 0"> 
    <ul class="pagination-list">
    <li><a class="pagination-previous " v-on:click="setPage(pagination.currentpage - 1)" :disabled="(pagination.currentpage <= 0)"><i class="fa fa-angle-left"></i></a></li>
    <li v-on:click="setPage(0)" ><a :class="{'is-current' : pagination.currentpage  == 0}" v-on:click="setPage(0)"  class="pagination-link" aria-label="Goto page 1">1</a></li>

    <li v-if="ellipsis && pagination.currentpage > 3"><span class="pagination-ellipsis">…</span></li>

    <li v-for="p in pages" v-on:click="setPage(p)" ><a :class="{'is-current' : pagination.currentpage  == p}" class="pagination-link" aria-label="Goto page">{{p + 1}}</a></li>

    <li v-if="ellipsis && pagination.currentpage < pagination.max-3"><span class="pagination-ellipsis">…</span></li>

    <li v-on:click="setPage(pagination.max)" ><a :class="{'is-current' : pagination.currentpage == pagination.max }" class="pagination-link" aria-label="Goto page">{{pagination.max + 1}}</a></li>
    <li><a class="pagination-next" v-on:click="setPage(pagination.currentpage + 1)" :disabled="(pagination.currentpage >= pagination.max)"><i class="fa fa-angle-right"></i></a></li>
    </ul>
    </nav>  
    `,
		created: function() {
			this.setPager();
		},
		watch: {
			pagination: {
				handler: function(after, before) {
					this.setPager();
				},
				deep: true
			}
		},
		data: function() {
			return {
				pages: [],
				ellipsis: false
			};
		},
		methods: {
			setPage: function(page) {
				if (page < 0 || page > this.pagination.max) return;
				// this.$emit('setpage', page);
				this.pagination.currentpage = page;
				this.setPager();
			},
			setPager: function() {
				this.pages = [];
				const arr = [];
				const pagi = this.pagination;
				this.ellipsis = false;
				if (pagi.max > 8) {
					if (pagi.currentpage < 4) {
						for (let i = 1; i < 5; i++) {
							arr.push(i);
						}
						this.ellipsis = true;
					} else if (pagi.currentpage > pagi.max - 4) {
						for (let i = pagi.max - 4; i < pagi.max; i++) {
							arr.push(i);
						}
						this.ellipsis = true;
					} else {
						this.ellipsis = true;
						for (let i = pagi.currentpage - 2; i < pagi.currentpage + 2 + (pagi.currentpage == 0 ? 1 : 0); i++) {
							if (i >= pagi.currentpage - 1 && i > 0 && i < pagi.max) {
								arr.push(i);
							}
						}
					}
				} else {
					for (let i = 1; i < pagi.max; i++) {
						arr.push(i);
					}
				}
				this.pages = arr;
			}
		}
	});
})();
